import { render, staticRenderFns } from "./RDayScheduleInstructionNew.vue?vue&type=template&id=88039dfe"
import script from "./RDayScheduleInstructionNew.vue?vue&type=script&lang=js"
export * from "./RDayScheduleInstructionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports